module.exports = __webpack_public_path__ + "static/img/CA-HTV.3377e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/CA-HTV.jpg
// module id = dAjX
// module chunks = 1